import { useState, useEffect } from "react";
import styles from "./OtherNAV.module.css";
import nzFlag from "../../../../common/assets/NavBar/NZFlag.png";
import maoriFlag from "../../../../common/assets/NavBar/MaoriFlag.png";
import levelUpLogo from "../../../../common/assets/NavBar/LevelUpWorks-white.png";
import { Link } from "react-router-dom";

const OtherNAV = ({ name, profile_pic, teacher_id, student_id }) => {   //props came from ParentOtherNav component
  const [isOpen, setIsOpen] = useState(false);
  const [isStudent, setIsStudent] = useState(false); //updated

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  if (isOpen) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }

  const handleLogout = () => {    //when trigger it will delete stored data in localStorage and can't access web contents
    localStorage.clear();
  };

  //updated
  useEffect(() => {
    if (teacher_id && teacher_id.length > 0) {
      setIsStudent(false);
    } else if (student_id && student_id.length > 0) {
      setIsStudent(true);
    }
  }, [teacher_id, student_id]);

  return (
    <div>
      <div className={styles.navbar}>
        <div className={styles.logo}>
          <Link to="/">
            <img src={levelUpLogo} className={styles.levelUpLogo} alt="" />
          </Link>
        </div>
        <div className={styles.menu}>
          <Link to="/">
            <div className={styles.menuItem}>HOME</div>
          </Link>
          <Link to="/projects-library">
            <div className={styles.menuItem}>PROJECTS</div>
          </Link>
          <div className={styles.menuItem}>TEACHERS</div>
        </div>
        <div className={styles.langFlagLogin}>
          <div className={styles.langFlag}>
            <div>
              <span className={styles.lang}>LANG</span>
            </div>

            <div>
              <img src={nzFlag} className={styles.flagNZ} alt=""></img>
            </div>
            <div>
              <img src={maoriFlag} className={styles.flagMaori} alt=""></img>
            </div>
          </div>

          {/* Dropdown section */}
          <div className={styles.avatarRegisterLogin}>
            <div className={styles.dropDown}>
              <div className={styles.dropDownToggle} onClick={toggleMenu}>
                <div>
                  <img src={profile_pic} className={styles.avatar} alt="Profile Pic" />
                </div>
                <div className={styles.registerLogin}>{name.toUpperCase()}</div>
              </div>
              <span className={isOpen ? styles.arrowUp : styles.arrowDown}></span> {/* for isosceles */}
              {/* updated */}
              {isOpen && isStudent && (
                <div className={styles.modal}>
                  <div onClick={toggleMenu} className={styles.overlay}>
                    <div className={styles.modalContent}>
                      <div class={styles.triangle}></div>
                      <ul className={styles.ul}>
                        <li className={styles.li}>
                          <Link to={`/student-profile-viewer/${student_id}`}>My Profile</Link>
                        </li>
                        <li className={styles.li}>Settings</li>
                        <li className={styles.li}>
                          <Link to="/" onClick={() => { handleLogout(); }}>Log out</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
              {/* updated */}
              {isOpen && !isStudent && (
                <div className={styles.modal}>
                  <div className={styles.overlay}>
                    <div className={styles.modalContent}>
                      <div class={styles.triangle}></div>
                      <ul className={styles.ul}>
                        <li className={styles.li}>
                          <Link to={`/teacher-profile-viewer/${teacher_id}`}>My Profile</Link>
                        </li>
                        <li className={styles.li}>Settings</li>
                        <li className={styles.li}>
                          <Link
                            to="/"
                            onClick={() => {
                              handleLogout();
                            }}
                          >
                            Log out
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherNAV;